import React from 'react';
// import WorldMap from 'react-svg-worldmap';
import { WorldMap } from 'react-svg-worldmap';

function WorldMapChart({ data }) {
  return (
    <div className="w-full h-full">
      {/* The WorldMap component will size itself responsively */}
      <WorldMap color="#4D62F4" valueSuffix=" scans" size="responsive" data={data} />
    </div>
  );
}

export default WorldMapChart;

